import { render, staticRenderFns } from "./ProTips.vue?vue&type=template&id=894ce7c6&scoped=true&"
import script from "./ProTips.vue?vue&type=script&lang=js&"
export * from "./ProTips.vue?vue&type=script&lang=js&"
import style0 from "./ProTips.vue?vue&type=style&index=0&id=894ce7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894ce7c6",
  null
  
)

export default component.exports